import type { OwaDate } from '../../../schema';
import convertToLunarCalendarDate from '../lunar/convertToLunarCalendarDate';
import type { LunarCalendarType } from './LunarCalendarType';

export type LunarDateStrings = {
    days: string[];
    months: string[];
    leapMonthCharacter: string;
};

export default function getIntlDateLunar(
    date: OwaDate,
    lunarCalendarType: LunarCalendarType,
    dateStrings: LunarDateStrings
): string {
    if (dateStrings.days.length !== 30 || dateStrings.months.length !== 12) {
        throw new Error('Invalid sized string array!');
    }

    const lunarDate = convertToLunarCalendarDate(date, lunarCalendarType);

    if (!lunarDate) {
        return '';
    }

    if (lunarDate.day === 1) {
        const month = dateStrings.months[lunarDate.month];

        return lunarDate.isLeapMonth ? dateStrings.leapMonthCharacter + month : month;
    }

    return dateStrings.days[lunarDate.day - 1];
}
